import i18n from 'i18next';

const changeLanguage = lang => {
  i18n.changeLanguage(lang);
  window.localStorage.setItem('defaultLanguage', lang);
};

// language switch
const languageMenu = (onMenuItemClick, t = null) => ({
  key: 'language',
  caption: 'Switch Language',
  subMenuItems: [
    {
      key: 'lang-en',
      caption: 'English',
      onClick: () => changeLanguage('en'),
    },
    {
      key: 'lang-fr',
      caption: 'French',
      onClick: () => changeLanguage('fr'),
    },
    {
      key: 'lang-es',
      caption: 'Spanish',
      onClick: () => changeLanguage('es'),
    },
  ],
});

export default languageMenu;
